import axios from "axios";
import interceptors from "@/shared/api/interceptors";

const apiClientAi = axios.create({
  baseURL: window.domain + "/NIC",
  withCredentials: true,
});

interceptors(apiClientAi);

export function sendChatMessage(text, config = {}) {
  return apiClientAi.post(
    "/classify",
    { text },
    { metaData: { isNotificationDisabled: true }, ...config }
  );
}

export function sendChat(text, sessionId, config = {}) {
  const body = { text };
  if (sessionId) body.session_id = sessionId;
  return apiClientAi.post("/chat", body, {
    metaData: { isNotificationDisabled: true },
    ...config,
  });
}

export function transcribeAudio(file) {
  const formData = new FormData();
  formData.append("file", file, file.name || "recording.webm");
  return apiClientAi.post("/transcribe", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    metaData: { isNotificationDisabled: true },
  });
}

export default apiClientAi;
